import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FunctionComponent } from "react";

interface ExclamationTriangleProps {
  text: string;
  className?: string;
}

const ExclamationTriangle: FunctionComponent<ExclamationTriangleProps> = ({
  text,
  className,
}) => {
  return (
    <div className={`text-center text-danger ${className}`}>
      <FontAwesomeIcon icon={faExclamationTriangle} /> <strong>{text}</strong>
    </div>
  );
};

export default ExclamationTriangle;
